import { CurrenciesRoutes as CurrenciesRoutesEnum } from '../routes';
import Currencies from '../hoc/currencies/currencies';
import CurrenciesList from '../hoc/currencies/list';
import CurrencyForm from '../hoc/currencies/form';

const CurrenciesRoutes = {
  path: CurrenciesRoutesEnum.CURRENCIES,
  element: <Currencies />,
  children: [
    {
      path: CurrenciesRoutesEnum.CURRENCIES_LIST,
      element: <CurrenciesList />,
      children: [
        {
          path: CurrenciesRoutesEnum.CURRENCIES_ITEM,
          element: <CurrencyForm />,
        },
      ],
    },
  ],
};

export default CurrenciesRoutes;
